if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      connectedCallback() {
        // Reels have their own viewport-aware playback controller.
        if (this.closest("video-reels")) return;
        this.isHeaderVideo = Boolean(this.closest("page-header-image-video"));
        this.startVisibleVideos = () => this.playVisibleVideos();
        if (this.isHeaderVideo) {
          this.resizeObserver = new ResizeObserver(this.startVisibleVideos);
          this.querySelectorAll("video").forEach((video) => this.resizeObserver.observe(video));
        }
        this.playVisibleVideos();
        requestAnimationFrame(this.startVisibleVideos);
        window.setTimeout(this.startVisibleVideos, 250);
        window.setTimeout(this.startVisibleVideos, 1000);
        this.addEventListener("touchstart", this.startVisibleVideos, { passive: true });
        this.addEventListener("click", this.startVisibleVideos);
        window.addEventListener("pageshow", this.startVisibleVideos);
        document.addEventListener("visibilitychange", this.startVisibleVideos);
      }

      getVisibleVideos() {
        return Array.from(this.querySelectorAll("video")).filter((video) => {
          const style = window.getComputedStyle(video);
          return style.display !== "none" && style.visibility !== "hidden"
            && (!this.isHeaderVideo || video.getClientRects().length > 0);
        });
      }

      playVisibleVideos() {
        if (document.visibilityState !== "visible") return;
        const visibleVideos = this.getVisibleVideos();
        if (this.isHeaderVideo) {
          this.querySelectorAll("video").forEach((video) => {
            if (!visibleVideos.includes(video)) video.pause();
          });
        }
        visibleVideos.forEach((video) => {
          video.autoplay = true;
          video.loop = true;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.preload = "auto";
          video.setAttribute("autoplay", "");
          video.setAttribute("loop", "");
          video.setAttribute("muted", "");
          video.setAttribute("playsinline", "");
          const attemptPlay = () => {
            if (document.visibilityState !== "visible") return;
            if (this.isHeaderVideo && !this.getVisibleVideos().includes(video)) return;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          };
          video.addEventListener("loadedmetadata", attemptPlay, { once: true });
          video.addEventListener("loadeddata", attemptPlay, { once: true });
          video.addEventListener("canplay", attemptPlay, { once: true });
          attemptPlay();
        });
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.removeEventListener("touchstart", this.startVisibleVideos);
        this.removeEventListener("click", this.startVisibleVideos);
        window.removeEventListener("pageshow", this.startVisibleVideos);
        document.removeEventListener("visibilitychange", this.startVisibleVideos);
      }
    },
  );
}

